var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"q-summit-sidebar-guide-line",class:{'q-summit-sidebar-guide-line--right': _vm.right }},[_c('svg',{attrs:{"width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('line',{attrs:{"y2":"0","x2":"100%","y1":"100%","x1":"0","stroke-dasharray":"8, 10","stroke":"#000","fill":"none"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }